module.exports = __webpack_public_path__ + "static/media/win.efbf1c13.png";